<template>
    <div class="container sitemap-page">

        <h1>Site Map</h1>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-6 col-xl-6">
          <div class="site-map">
          </div>
          <div class="site-map mb-5">
            <ul>
              <li>
                <router-link to="/">
                  <p class="sub-title">Home</p>
                </router-link>
                <hr />
              </li>
              <li>
                <router-link to="/privacy-policy">
                  <p class="sub-title">Privacy Policy</p>
                </router-link>
                <hr />
              </li>
              <li>
                <router-link to="/terms-and-conditions">
                  <p class="sub-title">Terms & Conditions</p>
                </router-link>
                <hr />
              </li>
              <li>
                <router-link to="/cookie-policy">
                  <p class="sub-title">Coookie Policy</p>
                </router-link>
                <hr />
              </li>
              <li>
                <router-link to="/accessibility-statement">
                  <p class="sub-title">Accessibility Statement</p>
                </router-link>
                <hr />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>


export default {
    components: {

    },
    data() {
        return {
        }
    },
}
</script>
<style>
   .container p{
        margin-bottom: 10px;
    }
    .site-map .title {
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 60px;
  color: black;
}
.sub-title {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 43px;
  color: black;
}
.sub-list {
  margin-left: 20%;
}
.text-white.banner-title {
  margin-left: 20%;
  font-weight: 400;
  margin-bottom: 30px;
}
.banner-sub {
  color: white;
  margin-left: 20%;
  width: 400px;
  font-size: 19px;
  line-height: 28px;
}
</style>
